import { RouteType } from 'types/RouteType';
import { RootStore } from 'stores/index';

const panelManagementRoute: RouteType = {
  name: 'Panel Management',
  path: '/admin/panel-management',
  layout: '/admin',
  viewportCard: {
    header: {
      title: 'Panel Management',
      enableBackButton: true,
      color: 'primary',
      component: () => import('./PanelManagement.Header'),
    },
    body: {
      component: () => import('./PanelManagement.Body'),
      grayBackground: false,
    },
  },
  dialogs: [
    {
      name: 'ConfirmDeleteDialog',
      title: 'Confirm Deletion',
      component: () => import('./PanelManagement.ConfirmDialog'),
    },
  ],
  group: 'Administration',
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Pre-load projects for job selection dropdown
    const projectsStore = rootStore.projectsStore as {
      find?: (query: Record<string, unknown>) => Promise<void>;
    };
    if (projectsStore?.find) {
      await projectsStore.find({ query: { $limit: 500 } });
    }
    return true;
  },
};

export default panelManagementRoute;
